<template>
    <div class="customerListsJGDS">
        <div class="searchBox">
            <div style="display: inline-block;" v-if="function_changeAuthAndGradesChanel">
                <p class="item">
                    <el-switch v-model="isOpenSign" @change="changeSwitch('isOpenSign')"></el-switch>
                    <span class="blue" v-if="isOpenSign">报名通道：开</span>
                    <span class="grey" v-if="!isOpenSign">报名通道：关</span>
                </p>
                <p class="item">
                    <el-switch v-model="isPublicPreGrade" @change="changeSwitch('isPublicPreGrade')"></el-switch>
                    <span class="blue" v-if="isPublicPreGrade">公布预赛成绩</span>
                    <span class="grey" v-if="!isPublicPreGrade">公布预赛成绩</span>
                </p>
                <p class="item">
                    <el-switch v-model="isPublicFinalGrade" @change="changeSwitch('isPublicFinalGrade')"></el-switch>
                    <span class="blue" v-if="isPublicFinalGrade">公布决赛成绩</span>
                    <span class="grey" v-if="!isPublicFinalGrade">公布决赛成绩</span>
                
                </p>
            </div>
            
            <p class="item">
                <el-button type="primary" @click="queryClick">刷新列表</el-button>
            </p>
            <br>
            <p class="item" v-if="function_uploadGrades" >
                <el-upload  class="uploadBox" accept=".xls,.xlsx" :show-file-list="false" :on-progress="uploadProgressPrev" :action="uploadBasicUrl+'/admin/file/readExcel'" :on-success="uploadSuccess" :on-error="uploadError">
                    <el-button  type="success">
                        上传预赛成绩表格<i class="el-icon-folder-opened"></i>
                        <el-progress type="circle" :percentage="prePercent"   width="10" v-if="prePercent>0&&prePercent<100"></el-progress>
                    </el-button>

                </el-upload>
                <el-upload class="uploadBox" accept=".xls,.xlsx" :show-file-list="false" :action="uploadBasicUrl+'/admin/file/readExcelByFinalResult'"
                    :on-success="uploadSuccess" :on-error="uploadError" :on-progress="uploadProgressFinal" >
                    <el-button type="success">上传决赛成绩表格 <i class="el-icon-folder-opened"></i>
                        <el-progress  type="circle" :percentage="finalPercent"   width="10" v-if="finalPercent>0&&finalPercent<100"></el-progress>

                    </el-button>
                </el-upload>

            </p>
            <p class="item">
                <el-button type="primary" @click="downloadUserList" v-loading="isLoadingUserDownload" v-if="function_downloadUserList">下载用户表格 <i class="el-icon-download"></i></el-button>
                <el-button type="primary" @click="getAllCard" v-loading="isLoadingCard" v-if="function_downloadUserCertify">下载所有选手预赛参赛证 <i class="el-icon-download"></i></el-button>
                <el-button type="primary" @click="getAllCard_final" v-loading="isLoadingCard_final"  v-if="function_downloadUserCertify">下载所有选手决赛参赛者 <i class="el-icon-download"></i></el-button>

            </p>
        </div>
        <div class="tableBox">
            <el-table :data="tableData" style="width: 100%" border :row-class-name="tableRowClassName">
                <el-table-column prop="date" label="序号" width="40">
                    <template slot-scope="scope">{{total-((searchObj.page-1)*searchObj.num+ scope.$index) }} </template>
                </el-table-column>
                <el-table-column prop="teamId" label="组别" width="60">
                    <template slot-scope="scope">{{scope.row.teamId}}组</template>
                </el-table-column>
                <el-table-column prop="name" label="姓名">
                    <template slot-scope="scope">
                        <div class="oneLine" v-for="(list,index) in scope.row.singupSubUser">{{list.user_realname}}</div>
                    </template>
                </el-table-column>

                <!-- <el-table-column prop="address" label="userID" width="60">
                    <template slot-scope="scope">
                        <div class="oneLine"  v-for="(list,index) in scope.row.singupSubUser">{{list.user_id}}</div>
                    </template>
                </el-table-column> -->
                <el-table-column prop="address" label="身份">
                    <template slot-scope="scope">
                        <div class="oneLine" v-for="(list,index) in scope.row.singupSubUser">
                            <span class="blue" v-if="list.user_is_leader=='y'">队长</span>
                            <span v-if="list.user_is_leader=='n'">队员</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="邀约状态">
                    <template slot-scope="scope">
                        <div class="oneLine" v-for="(list,index) in scope.row.singupSubUser">
                            <span v-if="list.invite_state=='y'" class="">已同意</span>
                            <span v-if="list.invite_state=='n'" class="orange_lighter">超时/拒绝</span>
                            <span v-if="list.invite_state=='p'" class="red">等待确定中</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="考试号">
                    <template slot-scope="scope">
                        <div class="oneLine" v-for="(list,index) in scope.row.singupSubUser">{{list.user_serial_number}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="考试日期" width="190">
                    <template slot-scope="scope">
                        <div class="oneLine" v-for="(list,index) in scope.row.singupSubUser">{{list.userExamDate}}
                            &nbsp; {{list.userExamTimeStr}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="报名手机号" width="120">
                    <template slot-scope="scope">
                        <div class="oneLine" v-for="(list,index) in scope.row.singupSubUser">{{list.phone}}</div>

                    </template>
                </el-table-column>
                <el-table-column prop="address" label="报名时间" width="150">
                    <template slot-scope="scope">
                        <div class="oneLine" v-for="(list,index) in scope.row.singupSubUser">{{list.signupTime}}</div>

                    </template>
                </el-table-column>
                <el-table-column prop="address" label="籍贯">
                    <template slot-scope="scope">
                        <div class="oneLine shengluehao" v-for="(list,index) in scope.row.singupSubUser">{{list.nativePlace}}</div>

                    </template>
                </el-table-column>

                <el-table-column prop="action" label="操作" width="60">
                    <template slot-scope="scope">
                        <div class="oneLine" v-for="(list,index) in scope.row.singupSubUser">
                            <span class="spanBtn" @click="toDetail(list)" v-if="list.user_id&&function_viewCustomerDetail">详情</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="pageBox">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
                :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total"
                background>
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        json,
        wordData,
        utils
    } from '@/common/common.js'
    import {
        ajaxPost,
        ajaxGet,
        api
    } from '@/common/request.js'

    export default {
        name: 'HelloWorld',
        data() {
            return {
                isLoadingUserDownload: false,
                isLoadingCard: false,
                isLoadingCard_final:false,
                isPublicFinalGrade: false,
                isPublicPreGrade: false,
                isOpenSign: false,
                tableData: [],
                searchObj: {
                    page: 1,
                    num: 10,
                },
                total: 0,
                prePercent:0,
                finalPercent:0
            }
        },
        components: {},
        computed: {
            uploadBasicUrl() {
                return api.baseUrl
            },
            imgPrev() {
                return api.imgPrev
            },
            function_viewCustomerDetail(){
                return utils.getCurrentFunction().indexOf("viewCustomerDetail")>-1
            },
            function_changeAuthAndGradesChanel(){
                return utils.getCurrentFunction().indexOf("changeAuthAndGradesChanel")>-1
            },
            function_uploadGrades(){
                return utils.getCurrentFunction().indexOf("uploadGrades")>-1
            },
            function_downloadUserList(){
                return utils.getCurrentFunction().indexOf("downloadUserList")>-1
            },
            function_downloadUserCertify(){
                return utils.getCurrentFunction().indexOf("downloadUserCertify")>-1
            },
        },
        methods: {
            uploadProgressPrev(event, file, fileList){
                console.log("正在上传中")
                console.log(event)
                this.prePercent=event.percent?parseInt(event.percent):0
            },
            uploadProgressFinal(event, file, fileList){
                this.finalPercent=event.percent?parseInt(event.percent):0
            },
            uploadError() {
                this.$message("上传文件失败")
            },
            uploadSuccess(res) {
                let _this = this
                let msg = ''
                if (res.errorCode == 200) {
                    msg = "上传成功" + ' ' + res.data
                    _this.$message({
                        message: msg, 
                        type: 'success',
                        duration: 2000
                    })

                    
                } else {
                    msg = res.errorMsg
                    _this.$message(msg)

                }
                

            },
            getAllCard_final(){
                let _this = this
                if (confirm("是否下载决赛参赛证")) {
                    _this.isLoadingCard_final = true
                    ajaxGet('/admin/file/downloadFinalQRcode')
                        .then(function(res) {
                            _this.isLoadingCard_final = false
                            if (res) {
                                var newStr = res.replace("/share", '')
                                window.location.href = _this.imgPrev + newStr
                            } else {
                                alert("返回下载链接错误")
                            }
                
                        })
                        .catch(function(error) {
                            _this.isLoadingCard_final = false
                            console.log(error);
                        });
                }

            },
            getAllCard() {
                let _this = this
                if (confirm("是否下载初赛参赛证")) {
                    _this.isLoadingCard = true
                    ajaxGet('/admin/file/downloadQRcode')
                        .then(function(res) {
                            _this.isLoadingCard = false
                            if (res) {
                                var newStr = res.replace("/share", '')
                                window.location.href = _this.imgPrev + newStr
                            } else {
                                alert("返回下载链接错误")
                            }

                        })
                        .catch(function(error) {
                            _this.isLoadingCard = false
                            console.log(error);
                        });
                }
            },
            downloadUserList() {
                let _this = this
                if (confirm("是否下载用户表格")) {
                    _this.isLoadingUserDownload = true
                    ajaxGet('/admin/file/exportUserExcel')
                        .then(function(res) {
                            _this.isLoadingUserDownload = false
                            if (res) {
                                var newStr = res
                                window.location.href = _this.imgPrev + newStr
                            } else {
                                alert("返回下载链接错误")
                            }

                        })
                        .catch(function(error) {
                            _this.isLoadingUserDownload = false
                            console.log(error);
                        });
                }
            },
            queryClick() {
                this.searchObj.num = 10
                this.searchObj.page = 1
                this.refrechPage()
            },
            refrechPage() {
                this.getSwitchDetail()
                this.getTableLists()
            },
            getSwitchDetail() {
                let _this = this
                ajaxPost('/admin/getEventInfo', {}).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.isPublicFinalGrade = res.data.event_finals_result_switch == 'on' ? true : false
                        _this.isPublicPreGrade = res.data.event_preliminary_result_switch == 'on' ? true :
                            false
                        _this.isOpenSign = res.data.event_signup_switch == 'on' ? true : false
                    }
                }, function(res) {

                })
            },
            changeSwitchAjax(arg) {
                let _this = this
                ajaxPost('/admin/updateEventInfo', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        _this.$message({
                            message: "切换成功",
                            type: 'success',
                            duration: 1500
                        });
                        _this.getSwitchDetail()
                    } else {
                        _this.getSwitchDetail()
                    }
                }, function(res) {
                    _this.getSwitchDetail()
                })

            },
            changeSwitch(type) {
                let _this = this
                let argKey = ''
                let arg = {
                    "eventId": "1",
                    "adminId": "1"
                }
                if (type == 'isOpenSign') {
                    if (confirm("确定更改报名通道开关吗")) {
                        argKey = "eventSignupSwitch"
                        arg[argKey] = _this.isOpenSign ? 'on' : 'off'
                        _this.changeSwitchAjax(arg)

                    } else {
                        setTimeout(function() {
                            _this.isOpenSign = !_this.isOpenSign
                        }, 100)
                    }
                }
                if (type == 'isPublicPreGrade') {
                    if (confirm("确定更改预赛成绩通道开关吗")) {
                        argKey = "eventPreliminaryResultSwitch"
                        arg[argKey] = _this.isPublicPreGrade ? 'on' : 'off'
                        _this.changeSwitchAjax(arg)
                    } else {
                        setTimeout(function() {
                            _this.isPublicPreGrade = !_this.isPublicPreGrade
                        }, 100)
                    }

                }
                if (type == 'isPublicFinalGrade') {
                    if (confirm("确定更改决赛成绩通道开关吗")) {
                        argKey = "eventFinalsResultSwitch"
                        arg[argKey] = _this.isPublicFinalGrade ? 'on' : 'off'
                        _this.changeSwitchAjax(arg)
                    } else {
                        setTimeout(function() {
                            _this.isPublicFinalGrade = !_this.isPublicFinalGrade
                        }, 100)
                    }

                }

            },
            tableRowClassName({
                row,
                rowIndex
            }) {
                if (rowIndex % 2 == 0) {
                    return 'success-row';
                } else {
                    return 'warning-row';
                }
                return '';
            },
            toDetail(list) {
                console.log(list)
                let userId = list.user_id
                this.$router.push({
                    name: "customerDetail",
                    params: {
                        userId: userId
                    }
                })
            },
            handleSizeChange(size) { //分页：每页n条
                this.searchObj.num = size
                this.searchObj.page = 1
                this.getTableLists()
            },
            handleCurrentChange(page) { //分页：改变第n页
                this.searchObj.page = page
                this.getTableLists()
            },
            getTableLists() {
                let _this = this
                let arg = JSON.parse(JSON.stringify(_this.searchObj))
                ajaxPost('/yijiajiaUserInfo/findSignupUser', arg).then(function(res) {
                    // _this.tableData=res.data.reviewList?res.data.reviewList:[]
                    console.log(res.data.singupUser, 'res.data.singupUser---------------')
                    if (res.data.singupUser && res.data.singupUser.length > 0) {
                        _this.tableData = res.data.singupUser.map(function(item, index) {
                            console.log(item, '-item----------------')
                            let leaderObj = {
                                invite_state: item.invite_state,
                                phone: item.phone,
                                userExamDate: item.userExamDate,
                                userExamTimeStr: item.userExamTimeStr,
                                user_id: item.user_id,
                                user_invite_parent_id: item.user_invite_parent_id,
                                user_is_leader: item.user_is_leader,
                                user_realname: item.user_realname,
                                user_serial_number: item.user_serial_number,
                                nativePlace: item.nativePlace,
                                signupTime: item.signupTime,
                            }
                            item.singupSubUser = item.singupSubUser ? item.singupSubUser : []
                            item.singupSubUser.unshift(leaderObj)
                            return item
                        })
                    }
                    _this.total = parseInt(res.data.totalCount)
                }, function(res) {

                })
            },
        },
        created() {

        },
        mounted() {
            let _this = this
            this.refrechPage()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    // *{outline: 1px solid blue;}
    .el-table .warning-row {
        background: oldlace;
    }

    // .el-table thead th{background: #333;color:#fff;}
    .el-table .success-row {
        background: #f0f9eb;
    }

    .customerListsJGDS {
        .uploadBox{
           display: inline-block;
        }
        
        .el-table .cell {
            padding: 0;
        }

        padding:0 10px;

        .tableBox {
            padding: 10px;
            background: #fff;

            .oneLine {
                border-bottom: 1px dotted #ddd;
                height: 35px;
                line-height: 35px;
            }

            .oneLine:nth-last-child(1) {
                border-bottom: none
            }
        }

        .searchBox {
            padding: 0 10px;

            .item {
                display: inline-block;
                margin-right: 70px;
                margin-top: 10px;
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/pages/customer/list.vue